import clsx from 'clsx';
import PropTypes from 'prop-types';

/**
 * StatusPill Application Component
 * 
 * Used for displaying status badges like "Win", "Loss", "Buy", "Sell"
 */
const StatusPill = ({ type = 'neutral', children, className }) => {
  const baseClasses = 'status-pill';
  const typeClasses = {
    success: 'status-pill-success',
    warning: 'status-pill-warning',
    danger: 'status-pill-danger',
    neutral: 'status-pill-neutral',
    info: 'status-pill-info'
  };

  return (
    <span className={clsx(baseClasses, typeClasses[type], className)}>
      {children}
    </span>
  );
};

StatusPill.propTypes = {
  type: PropTypes.oneOf(['success', 'warning', 'danger', 'neutral', 'info']),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default StatusPill;
